const vehicleAlarm = {
  overspeedRule: {
    ruleName: 'Rule name',
    carCount: 'Number of vehicles in the regulation',
    createdOn: 'Creation time',
    add: 'Add rule',
    edit: 'Edit rule',
    carList: 'Car list',
    errorName: 'Please enter rule name',
    errorSpeed: 'Please enter speed(Digit)',
    bound: 'Bound',
    unbound: 'Unbound',
    ruleCar: 'Vehicle information for which rules have been set',
    noRuleCar: 'Vehicle information with no rules set',
    addCar: 'Add vehicle',
    deleteCar: 'Delete vehicle',
    subUserTip: "You can create a over speed alarm rule to your "
  },
  overspeedRecord: {
    alarmTime: 'Alarm time',
    ruleName: 'Rule name',
    startAddress: 'Start address',
    endAddress: 'End address',
    startSpeed: 'Start speed(km/h)',
    endSpeed: 'End speed(km/h)',
  },
  maxSpeed: 'Maximum speed(km/h)',
  remark: 'Remark'
}
export default vehicleAlarm